import mixpanel from '@disco/api/mixpanel'
import { copyToDisco } from '@disco/state-management/actions/ExplorerActions'
import { getTeamLibrary } from '@disco/state-management/selectors/groups'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { Group } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import type { Track } from 'types/track'
import { useMenu } from 'components/ds'
import Submenu from 'components/track-actions/submenu/dropdown-submenu'

type Props = {
  track: Track
  excludeShortlistId: string | null | undefined
  sourceShortlistId?: string | null | undefined
  sourcePlaylistId?: PlaylistId | null | undefined
  closeMenu: () => void
  group?: Group | null | undefined
  disabled: boolean
  addToCustomGroup: boolean
  channelOwner?: number | null | undefined
}

const CopyTrackToOption = ({
  closeMenu,
  track,
  group,
  channelOwner,
}: Props): React.ReactNode => {
  const Menu = useMenu()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const teamLibrary = useSelector(getTeamLibrary)
  const groupId = group?.id

  const links: React.ReactNode[] = [
    <Menu.Item
      key="browse"
      onSelect={() => {
        const teamLibraryId = teamLibrary?.id
        if (!teamLibraryId) return
        dispatch(
          copyToDisco(
            track.name,
            track?.stream_url,
            { groupIds: [teamLibraryId] },
            groupId,
          ),
        )
        mixpanel.sendPureEvent('Copy Shared Item', {
          Context: 'Shared Channels',
          Track_Name: track.name,
          Location: 'Shared Channel - Track Action Menu',
          Copy_To_Location: 'Browse',
          Copy: 'Browse',
          Type: 'Track',
          'Channel ID': groupId,
          'Channel Owner': channelOwner,
        })
        closeMenu()
      }}
    >
      Browse
    </Menu.Item>,
  ]

  if (groupId) {
    links.push(
      <Menu.Item
        key="channel"
        onSelect={() => {
          mixpanel.sendPureEvent('Copy Shared Item', {
            Context: 'Shared Channels',
            Track_Name: track.name,
            Location: 'Shared Channel - Track Action Menu',
            Copy_To_Location: 'Channel',
            Copy: 'Channel',
            Type: 'Track',
            'Channel ID': groupId,
            'Channel Owner': channelOwner,
          })
          navigate(`/explorer/tracks/${track.id}/${groupId}/copy-to-channel`)
        }}
      >
        Channel
      </Menu.Item>,
      <Menu.Item
        key="playlist"
        onSelect={() => {
          mixpanel.sendPureEvent('Copy Shared Item', {
            Context: 'Shared Channels',
            Track_Name: track.name,
            Location: 'Shared Channel - Track Action Menu',
            Copy_To_Location: 'Playlist',
            Copy: 'Playlist',
            Type: 'Track',
            'Channel ID': groupId,
            'Channel Owner': channelOwner,
          })
          navigate(`/explorer/tracks/${track.id}/${groupId}/copy-to-playlist`)
        }}
      >
        Playlist
      </Menu.Item>,
    )
  }

  return <Submenu links={links} title="Copy to" />
}

export default CopyTrackToOption
